<template>
  <div class="sakura-box" ref="sakuraBox">
    <div class="btn-question" @click="modelType = 3">
      怎么使用存档
    </div>
    <div class="btn-feedback" @click="modelType = 5">
      <img src="@/assets/sakuraBox/feed-back.png" alt="">
    </div>
    <div class="to-top" @click="toTop">顶部</div>
    <img class="banner" src="@/assets/sakuraBox/banner.png" alt="">
    <div class="game-box-pink box-pink" v-if="isHideBlock">
      <img class="icon-close active" v-if="exclusiveSource !== '233zhuanshu'" @click="isHideBlock = false" src="@/assets/sakuraBox/icon-close-mask.png" alt="" />
      <div class="game-box">
        <div class="game-icon">
          <img :src="iconUrl + '?image_process=format,png'" alt="">
        </div>
        <div class="game-name ellipsis">{{displayName}}</div>
        <div class="game-info">{{gameDownCount}}+玩过 | {{gameFileSize}}</div>
        <div class="btn-start-game btn" @click="clickBtn"></div>
      </div>
      <div class="ad-tag" v-if="exclusiveSource !== '233zhuanshu'">AD</div>
    </div>
    <div class="box-pink" v-if="exclusiveSource === '233zhuanshu'" :class="exclusiveSource === '233zhuanshu' ? 'sourc-box-pink' : ''">
      <div class="user-box">
        <div class="tab-list">
          <div class="big-tab">
            <img src="@/assets/sakuraBox/record-create-source.png" alt="" @click="modelType = 7">
          </div>
        </div>
      </div>
    </div>
    <RecordList @changeMaskLoadingflag="changeMaskLoadingflag" @openPanel="openPanel" v-if="active === 1"></RecordList>
    <Model ref="Model" @openPanel="openPanel" :modelType='modelType' @closePanel="closePanel"></Model>
    <div @click="modelType = 6" class="user-privacy">用户协议和隐私政策</div>
    <div class="maskLoading" v-show="maskLoadingflag">
      <img src="@/assets/images/load.svg" alt />
    </div>
  </div>
</template>

<script>
import RecordList from './components/RecordList.vue';
import Model from './components/Model.vue';
import config from '@/../config';
import active from '@/utils/axios/index';
import qs from 'qs';
export default {
  name: 'SakuraBoxApp',
  components: {
    RecordList,
    Model,
  },
  data() {
    return {
      isHideBlock: true,
      gameId: '77793', // 樱花校园模拟器2021游戏id
      gameInf: {}, // 游戏信息
      iconUrl: '', // 游戏icon
      displayName: '', // 游戏名称
      gameFileSize: '', // 游戏大小
      gameDownCount: '', // 游戏下载次数
      status: 0, // 下载的状态 0 未下载, 1.暂停, 2.成功/已安装, 3.失败, 4.下载中
      active: 1,
      swiperIndex: 0,
      modelType: false,
      maskLoadingflag: true, // 首页进入页面开始的动画(转圆圈)
      exclusiveSource: '' // 专属来源
    };
  },
  mounted() {
    this.$tea('event_sakura_box_show', {source: 'sakuraBoxApp'}); // 展示页面
    this.getGamesByIds();
    this.exclusiveSource = this.$route.query.source;
  },
  methods: {
    // 根据gameId获取游戏信息
    getGamesByIds() {
      active.getGamesByIds(
          config.API_HOST + '/apiserv/api/repository/game/getGamesByIds',
          qs.stringify({ids: this.gameId}),
      ).then((res) => {
        if (res.return_code != 200) {
          this.$toast(res.return_msg || res.message || res.msg);
          return;
        }
        this.gameInf.detail = res.data[0].detail;
        this.iconUrl = res.data[0].detail.iconUrl;
        this.displayName = res.data[0].detail.displayName;
        this.conver(res.data[0].detail.fileSize);
        this.converMillion(res.data[0].detail.appDownCount);
      }).catch((error) => {
        this.$toast('网络不稳定，请稍后');
      });
    },
    /**
   * 跳转游戏圈
   * @return {void}
   */
    jumpToArticle() {
      if (!this.pushDataList[this.swiperIndex]) return;
      if (this.pushDataList[this.swiperIndex].type === 1) {
        window.location.href = this.pushDataList[this.swiperIndex].link;
      } else {
        this.$refs.Model.openPageInApp();
      }
    },
    changeMaskLoadingflag() {
      this.maskLoadingflag = false;
    },
    openPanel(type, id) {
      this.modelType = type;
    },
    // 返回顶部
    toTop() {
      try {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      } catch {
        window.scrollTo(0, 0);
      }
    },
    // 关闭弹窗
    closePanel() {
      this.modelType = false;
    },
    // 下载按钮点击
    clickBtn() {
      this.$tea('event_sakura_box_open_app_click',{ source: 'sakuraBoxApp' }) // 点击开始游戏或者打开游戏圈
      if (typeof metaTools != 'undefined' && metaTools.checkAppInstalled('com.meta.box') == 1) { // 樱花发布到233渠道包专属
        const params = `funId=5&acquired=0&clickTime=${new Date().getTime()}&info={}&url=metaapp://233xyx/detail/game?key_game_id=77793`;
        window.location.href = 'metaapp://233xyx/web/web?' + params;
        return;
      }
      this.modelType = 2;
    },
    // KB MB GB等的转化
    conver(limit) {
      let sizestr = '';
      if (limit < 0.1 * 1024) {
        // 如果小于0.1KB转化成B
        sizestr = limit.toFixed(2) + 'B';
      } else if (limit < 0.1 * 1024 * 1024) {
        // 如果小于0.1MB转化成KB
        sizestr = (limit / 1024).toFixed(2) + 'KB';
      } else if (limit < 1024 * 1024 * 1024) {
        // 如果小于0.1GB转化成MB
        sizestr = (limit / (1024 * 1024)).toFixed(2) + 'MB';
      } else {
        // 其他转化成GB
        sizestr = (limit / (1024 * 1024 * 1024)).toFixed(2) + 'GB';
      }
      const len = sizestr.indexOf('.');
      const dec = sizestr.substr(len + 1, 2);
      if (dec == '00') {
        // 当小数点后为00时 去掉小数部分
        this.gameFileSize = sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
      } else {
        this.gameFileSize = sizestr;
      }
    },
    // 下载数值过万处理
    converMillion(value) {
      let num;
      if (value > 9999) {
        // 大于9999显示x.xx万
        num = Math.floor(value / 1000) / 10 + 'W';
      } else if (value < 9999 && value > -9999) {
        num = value;
      } else if (value < -9999) {
        // 小于-9999显示-x.xx万
        num = -(Math.floor(Math.abs(value) / 1000) / 10) + 'W';
      }
      this.gameDownCount = num;
    },
  },
};
</script>

<style scoped>
  .icon-close {
    width: 13px;
    height: 13px;
    position: absolute;
    top: 3px;
    right: 3px;
    z-index: 10;
    background: white;
    border-radius: 50%;
  }
  .maskLoading {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 999;
    background: rgba(245, 156, 194, 0.98);
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .maskLoading img {
    display: block;
    width: 0.4rem;
    height: 0.4rem;
    animation: loading 2s linear 0s infinite;
  }
  @keyframes loading {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
  }
  img{
    width: 100%;
    height: 100%;
    display: block;
  }
  .ellipsis{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .sakura-box{
    background: #FFF0F0;
    min-height: 100vh;
    padding-bottom: 20px;
  }
  .banner{
    width: 100%;
    height: 231px;
    display: block;
  }
  .box-pink{
    width: 352px;
    border-radius: 9px;
    background: #FFADCE;
    position: relative;
    z-index: 2;
    border: solid 1px #FA7CB5;
    padding-bottom: 2px;
    margin: 0 auto;
  }
  .game-box-pink{
    margin: -39px auto 10px auto;
    position: relative;
  }
  .game-box{
    width: 352px;
    height: 81px;
    border-radius: 9px;
    background: white;
    border: solid 1px #FA7CB5;
    padding: 20px 150px 0 76px;
    transform: translate(-1px,-1px);
  }
  .game-icon{
    width: 58px;
    height: 58px;
    border-radius: 8px;
    overflow: hidden;
    position: absolute;
    top: 11px;
    left: 10px;
  }
  .ad-tag{
    width: 48px;
    height: 18px;
    /* background: url('~assets/sakuraBox/icon-plan.png') no-repeat; */
    /* background-size: 14px 14px; */
    /* background-position: left center; */
    position: absolute;
    bottom: 0px;
    right: -10px;
    font-size: 12px;
    color: white;
    transform: scale(0.6);
    /* padding-left: 20px; */
    line-height: 18px;
    background: rgba(0,0,0,0.4);
    border-radius: 12px 0 12px 0;
    text-align: center;
    opacity: 0.4;
  }
  .btn-start-game{
    width: 62px;
    height: 31px;
    background: url('~assets/sakuraBox/btn-start-game.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 20px;
    right: 11px;
  }
  .btn-open-game{
    width: 62px;
    height: 31px;
    background: url('~assets/sakuraBox/btn-open-game.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 27px;
    right: 11px;
  }
  .btn-download-game{
    width: 62px;
    height: 31px;
    background: url('~assets/sakuraBox/btn-download-game.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 27px;
    right: 79px;
    font-size: 13px;
    line-height: 31px;
    text-align: center;
    /* -webkit-text-stroke: 1px #E7373D; */
    /* text-stroke: 1px #E7373D; */
    text-shadow: #E7373D 1px 0 0, #E7373D 0 1px 0, #E7373D -1px 0 0, #E7373D 0 -1px 0;
    color: #fff;
  }
  .btn-game-circle{
    width: 62px;
    height: 31px;
    background: url('~assets/sakuraBox/btn-game-circle.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 27px;
    right: 11px;
  }
  .btn:active{
    transform: scale(0.9);
  }
  .game-name{
    font-size: 13px;
    font-weight: 500;
    color: #000000;
    margin-bottom: 4px;
  }
  .game-info{
    width: 200%;
    font-size: 18px;
    color: #969092;
    transform: scale(0.5) translate(-50%,-50%);
  }
  .user-box{
    width: 352px;
    /* height: 109px; */
    background: white;
    border-radius: 9px;
    border:solid 1px #FA7CB5;
    transform: translate(-1px,-1px);
    position: relative;
    padding: 14px 0;
  }
  .icon-bookmark{
    width: 21px;
    height: 28px;
    position: absolute;
    left: 20px;
    top: -5px;
    background: url('~assets/sakuraBox/icon-bookmark.png') no-repeat;
    background-size: 100% 100%;
  }
  .head-img-shadow{
    width: 41px;
    height: 41px;
    position: absolute;
    left: 10px;
    top: 10px;
    background: #FFE0ED;
    border-radius: 50%;
  }
  .head-img{
    width: 41px;
    height: 41px;
    position: absolute;
    left: 10px;
    top: 6px;
    border:solid 1px #E60C96;
    border-radius: 50%;
    z-index: 2;
    overflow: hidden;
  }
  .user-name{
    line-height: 18px;
    position: relative;
    font-size: 14px;
    padding: 20px 20px 18px 60px;
  }
  .user-name span{
    color: #FA7CB5;
    display: block;
    float: left;
    max-width: 88px;
    padding-right: 6px;
  }
  .tab-list{
    width: 100%;
    /* height: 38px; */
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  .tab{
    width: 101px;
    height: 38px;
  }
  .tab:active{
    transform: scale(0.9);
  }
  .big-tab img{
    width: 70%;
    margin: 0 auto;
    height: auto;
  }
  .btn-question{
    width: 108px;
    height: 24px;
    opacity: 0.3;
    position: absolute;
    right: 0;
    top: 160px;
    border-radius: 12px 0 0 12px;
    color: white;
    line-height: 24px;
    padding-left: 26px;
    background-image: url('~assets/sakuraBox/icon-question.png');
    background-repeat: no-repeat;
    background-size: 16px 16px;
    background-position: left 6px center;
    background-color: #000000;
    font-size: 12px;
  }
  .btn-feedback{
    position: absolute;
    right: 0;
    top: 78px;
    width: 25px;
  }
  .to-top{
    width: 60px;
    height: 30px;
    opacity: 0.3;
    position: fixed;
    right: 0;
    bottom: 30px;
    border-radius: 15px 0 0 15px;
    color: white;
    line-height: 30px;
    padding-left: 28px;
    background-image: url('~assets/sakuraBox/to-top.png');
    background-repeat: no-repeat;
    background-size: 14px 11px;
    background-position: left 10px center;
    background-color: #000000;
    font-size: 12px;
    z-index: 5;
  }
  .nav-return{
    width: 11px;
    height: 19px;
    position: absolute;
    left: 17px;
    top: 34px;
  }
  .nav-share{
    width: 19px;
    height: 19px;
    position: absolute;
    right: 19px;
    top: 34px;
  }
  .nav-bar{
    width: 100%;
    height: 69px;
    padding-top: 16px;
    line-height: 49px;
    text-align: center;
    font-size: 17px;
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
  }
  .login-btn{
    position: absolute;
    color: #F967A4;
    font-size: 12px;
    right: 12px;
    top: 50%;
    transform: translateY(-55%);
  }
  .user-privacy{
    margin-top: 10px;
    text-align: center;
    text-decoration: underline;
    color: #FA7CB5;
  }
  .user-privacy:active{
    transform: scale(0.9);
  }
  .news_box{
      width: 326px;
      height: 20px;
      border-radius: 10px;
      margin: 10px auto 0;
      position: relative;
      padding: 0 16px 0 23px;
      margin-bottom: 12px;
      overflow: hidden;
  }
  .swiper-container{
      height: 0.42rem;
  }
  .swiper-slide{
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding-right: 40px;
      font-size: 11px;
      color: rgba(0,0,0,0.8);
      opacity: 0.78;
      height: 21px;
      line-height: 21px;
  }
  .news_box::before{
      content: "";
      width: 15px;
      height: 20px;
      background: url('~assets/sakuraBox/notice.png') no-repeat;
      background-size: 14px 12px;
      background-position: left center;
      position: absolute;
      left: 0;
      top: 0;
  }
  .see_link{
      font-size: 12px;
      color: #E83782;
      height: 20px;
      line-height: 20px;
      position: absolute;
      right: 0;
      top: 0;
  }
  .sourc-box-pink .user-name{
      padding-left: 14px;
      padding-right: 14px;
  }
</style>
